/* eslint-disable quotes */
/* eslint-disable max-len */
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
} from '@angular/core';
import { FlexLayoutType } from '../../constants/flex-layout.type';
import { StatusType } from '../../constants/status.type';
import { StatusTextType } from '../../constants/status-text.type';
import { HearingRequestDetailsModel } from '../../models/hearing-request-details.model';
import { ConfirmationDialogComponent } from '../../dialogs/confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
@Component({
  selector: 'jsg-action-hearing-tab-card-view',
  templateUrl: './action-hearing-tab-card-view.component.html',
  styleUrls: ['./action-hearing-tab-card-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActionHearingTabCardViewComponent implements OnInit, OnDestroy {
  @Input() hearingRequest: HearingRequestDetailsModel;
  @Input() calendarRoute: string;
  @Input() hearingDetailsRoute: string;
  @Input() showCalendarButton: boolean = true;
  @Input() showAdjournmentButton: boolean = false;
  @Input() showViewDetailsButton: boolean = false;

  @Output()
  adjournButtonClick: EventEmitter<HearingRequestDetailsModel> = new EventEmitter<HearingRequestDetailsModel>();

  private cancelAssociateMaterialsDialogSubscription: Subscription;

  public FlexLayoutType = FlexLayoutType;
  public StatusType = StatusType;
  public StatusTextType = StatusTextType;

  get expanded(): boolean {
    if (
      this.hearingRequest?.hearingHistory.some(
        (h) => h.hearingStatusCode == StatusType.AdjournmentRejected
      )
    )
      return true;
    else return false;
  }

  constructor(private dialog: MatDialog) {}

  ngOnInit(): void {}

  onAdjournButtonClick = (hearingRequest: HearingRequestDetailsModel) => {
    if (this.hearingRequest?.userHearingAccess?.canAdjourn) {
      this.cancelAssociateMaterialsDialogSubscription = this.dialog
        .open(ConfirmationDialogComponent, {
          autoFocus: false,
          disableClose: true,
          width: '600px',
          data: {
            caption: 'Request Adjournment',
            subcaption:
              "All parties will be required to re-associate their materials to the adjourned hearing once it's approved. Do you wish to proceed?",
            confirmButton: 'Yes, proceed',
            cancelButton: 'No, cancel',
          },
        })
        .afterClosed()
        .subscribe((isConfirmed: boolean) => {
          if (!isConfirmed) {
            return;
          }
          this.adjournButtonClick.emit(hearingRequest);
        });
    }
  };

  ngOnDestroy(): void {
    this.cancelAssociateMaterialsDialogSubscription?.unsubscribe();
  }
}
